import Pagination from '@mui/material/Pagination';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, handleDateChange, initializeFilterData, convertToNumber } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { InvoiceCard } from "../CommonComponents/Table";
import { GetSession } from '../CommonComponents/cryptoUtils';

const MISReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    const [result, setResult] = useState({ Data: [] });
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [Response, setResponse] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [mobileNo, setmobileNo] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const inputrefs = useRef([]);
    const commonData = CommonApiData();
    const LoginType = GetSession('cookies', 'loginUserType');
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
        "dealer": "",
        "mobileNo": "",
        "invoiceNo": "",
        "IMEI": "",
        "ProductCode": "",
        "PaymentStatus":""
    })


    const handleChange1 = (event, value) => {
        GetMISReport(value);
    };
    const handleClear = async () => {
        await setFormData({
            ...Data,
            "fromDate": dateArr,
            "toDate": dateArr,
            "dealer": "",
            "mobileNo": "",
            "invoiceNo": "",
            "IMEI": "",
            "ProductCode": "",
            "PaymentStatus": ""
        });
        inputrefs.current['txtFromDate'].focus();
        setShowOtpInput(false);
        setIsDisabled(false);
        setResponse({});
        setResult({ Data: [] });

    };

    const GetMISReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            loginUserType: LoginType,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Report/MISReport', GetData)
        await dispatch(setSubLoading(false))
        if (data.Status === 'SUCCESS') {
            setResult(data)
        }
        else if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message);
        } else  {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
            setResult(data)
        }
        await dispatch(setSubLoading(false))
    }

    const handleSendOtp = async (id, OnlinePaymentID, policy,type) => {
        try {
            let data = await ApiCall(`/api/Login/SendOTPToMobileNo`, { ...formData, onlinePaymentID: OnlinePaymentID, policyNo: policy ? policy : '', type:'CancellationOTP' });
            setResponse(data)
            setFormData(prevData => ({ ...prevData, otp: '', onlinePaymentID: OnlinePaymentID, validate: '' }));
            if (data.status === 'SUCCESS') {
                await setIsModalOpen(true)
                await setTimer(300);
                await setIsDisabled(true);
                setShowOtpInput(true);
            } else if (data.status === 'ERROR') {
                await setIsModalOpen(false)
                setShowOtpInput(false);
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
        }
    };
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/DealerMaster/InsertCancellationRequest`, { ...formData, onlinePaymentID: (formData.onlinePaymentID).toString(), mobileNo: formData.mobileNo || '', type:'MISReport' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs);
        if (data.status === 'SUCCESS') {
            formData.onlinePaymentID = data.onlinePaymentID;
            await handleSubmitRefundTransaction();
            await setIsModalOpen(false);
            await setFormData({ ...formData, otp: '' });
        }
    };
    const handleSubmitRefundTransaction = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/SalesEntryAPI/RefundTransaction`, { Type: 'SaleCancellation', OnlinePaymentID: (formData.onlinePaymentID).toString() || '' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, GetMISReport);

    };
    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
            setIsModalOpen(false)
        }

        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        loginUserType: LoginType,
        Type: 'E',
        PageIndex: '1'
    }
    const countNo = Math.ceil((parseInt(result?.TotalRecord) / parseInt(result?.PageSize)));

    const borderColors = ['#FF5733', '#33FF57', '#3357FF', '#F1C40F', '#8E44AD'];

    useEffect(() => {
        if (Object.keys(formData).length > 0) {
            GetMISReport(formData); 
            inputrefs.current['txtFromDate'].focus()
            document.title = 'Sale Report'
        }
    }, []); 
    

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Sale Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            required={true}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            required={true}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    if (LoginType === 'Admin') {
                                        inputrefs.current['txtDealer'].focus();
                                    } else {
                                        inputrefs.current['txtMobileNo'].focus();
                                    }
                                }
                            }}
                        />
                        {LoginType === "Admin" && (
                            <AutoCompleteBoxNew
                                id="txtDealer"
                                placeholder="Dealer"
                                label={'Dealer'}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtMobileNo'].focus()
                                    }
                                }}
                                contextKey={formData.dealer}
                                autocompleteType='GetDealerMaster'
                                value={formData.dealer || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, dealer: newInputValue })
                                    }
                                }}
                                maxLength='50'
                            />
                        )}
                        <InputBox
                            label='Mobile No'
                            placeholder='Mobile No'
                            inputrefs={inputrefs}
                            id='txtMobileNo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtInvoice'].focus() };
                            }}
                            value={formData.mobileNo}
                            onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                            autoComplete="off"
                        />
                        <InputBox
                            label='Invoice No'
                            placeholder='Invoice No'
                            inputrefs={inputrefs}
                            id='txtInvoice'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtIMEINo'].focus() };
                            }}
                            value={formData.invoiceNo}
                            onChange={(e) => setFormData({ ...formData, invoiceNo: e.target.value })}
                            autoComplete="off"
                        />
                        <InputBox
                            label='IMEI No'
                            placeholder='IMEI No'
                            inputrefs={inputrefs}
                            id='txtIMEINo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtProductCode'].focus() };
                            }}
                            value={formData.IMEI}
                            onChange={(e) => setFormData({ ...formData, IMEI: e.target.value })}
                            autoComplete="off"
                        />
                        <AutoCompleteBoxNew
                            id="txtProductCode"
                            placeholder="Product"
                            label={'Product'}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus()
                                }
                            }}
                            autocompleteType='GetProductCode'
                            value={formData.ProductCode || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, ProductCode: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />
                        <SelectInputBox
                            id="txtStatus"
                            label='Payment / Policy Status'
                            value={formData.PaymentStatus}
                            onChange={(e) => setFormData({ ...formData, PaymentStatus: (e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus();
                                }
                            }}
                        >
                            <option value=''>--Please Select Status--</option>
                            <option key="PolicyGenerated" value="PolicyGenerated">Policy Generated</option>
                            <option key="PaidButPolicyNotGenerated" value="PaidButPolicyNotGenerated">Paid But Policy Not Generated</option>
                            <option key="PaymentFailed" value="PaymentFailed">Payment Failed</option>
                            <option key="PendingSale" value="PendingSale">Pending Sale</option>
                        </SelectInputBox>
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetMISReport}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Report/MISReport', ExportRequest, 'MIS Report');
                                    dispatch(setSubLoading(false))
                                }
                                finally { dispatch(setSubLoading(false)) }
                            }} >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>

            <div>
                {result?.TotalRecord > 0 ? (
                    <>
                        <div className='card col-md-4 px-2 p-3'>
                            <h6 className='m-0 d-flex gap-2'>
                                <span>{`${result?.TotalRecord !== undefined ? 'Total Records : ' + result?.TotalRecord : (result?.Data?.length ? 'Total Records : ' + result?.Data?.length : 'No Record Found')}`}</span>
                            </h6>
                        </div>
                        {result?.Data?.map((invoice, index) => (
                            <InvoiceCard
                                key={index}
                                invoice={invoice}
                                handleCheck={handleSendOtp}
                                currentPageNo={currentPageNo}
                                result={result}
                                handleChange1={handleChange1}
                                borderColor={borderColors[index % borderColors.length]}
                            />
                        ))}
                        {countNo > 1 ? (
                            <Pagination
                                className='pt-2'
                                count={countNo}
                                variant="outlined"
                                page={currentPageNo}
                                onChange={handleChange1}
                                shape="rounded"
                                color='primary'
                            />
                        ) : null}
                    </>
                ) : (
                    <div className='main-card card border-0'>
                        <h6 className="norecordFound p-4" style={{ fontWeight: "bold" }}>No records found!</h6>
                    </div>
                )}

            </div>
            <Modal show={isModalOpen} style={{ cursor: 'pointer' }} backdrop="static" onHide={() => setIsModalOpen(false)} >
                <Modal.Header closeButton style={{ background: "mintcream" }}>
                    <Modal.Title><h6 className="modal-title d-flex" id="exampleModalLabel">
                        OTP for Policy Cancellation
                    </h6></Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ background: "mintcream", maxHeight: '450px', maxWidth: '700px', padding: '8px' }} className='modal-body table-responsive'>
                    <div className='p-2 px-4 mb-1' >
                        {isDisabled &&
                            <label className={'text-success fs-6'}>{Response.message}</label>
                        }
                        {showOtpInput && (
                            <>
                                <InputBox
                                    id="txtotp"
                                    labelclass='form-label fw-bold mb-0'
                                    label={"Enter 6 Digit OTP"}
                                    divclassname='col-md-12'
                                    inputrefs={inputrefs}
                                    value={formData.otp}
                                    maxLength={6}
                                    onChange={(e) => setFormData({ ...formData, otp: convertToNumber(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                />
                                <p style={{}} className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                    Didn't receive an OTP?
                                    <button
                                        type="button"
                                        onClick={handleSendOtp}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#007bff',
                                            fontWeight: 'bold',
                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                            marginLeft: '7px',
                                            opacity: isDisabled ? 0.5 : 1,
                                        }}
                                        disabled={isDisabled}
                                    >
                                        {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                    </button>
                                </p>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ background: "mintcream" }}>
                    <button type="button"
                        onClick={() => handleSubmit()}
                        className="btn btn-rounded btn-sm btn-success"
                    >
                        <span className=" text-warning me-1">
                            <i className="fa fa-save text-white color-success">
                            </i>
                        </span>Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default MISReport;